exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".mobile-menu-header{display:none}@media screen and (max-width: 991px){.nav>li>a{padding:10px}}@media screen and (max-width: 767px){.navbar-collapse{display:block;position:fixed;width:60%;height:100vh;left:-60%;top:0;background:#fff;transition:left 0.15s ease-in-out;z-index:999}.navbar-collapse.show{left:0px}.navbar-collapse.show ul.menuItemText li{width:100%}.navbar-collapse.show ul.menuItemText li a{color:#222;padding-left:5px;text-align:left}.menu-backdrop{top:0;width:100%;height:100vh;z-index:900;position:fixed;display:block;z-index:900;background-color:rgba(0,0,0,0.75)}.mobile-menu-header{display:block;border-bottom:1px solid #eee;width:100%}.mobile-menu-header i{font-size:20px;color:#222}.mobile-menu-header .mobile-menu-header-content{margin-left:20px}}@media screen and (max-width: 575px){.navbar-collapse{width:80%;left:-80%}}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/Component/Navigation.scss
// module id = 1095
// module chunks = 0